import { render, staticRenderFns } from "./projectsDetails.vue?vue&type=template&id=d81fd23a&scoped=true&"
import script from "./projectsDetails.vue?vue&type=script&lang=js&"
export * from "./projectsDetails.vue?vue&type=script&lang=js&"
import style0 from "./projectsDetails.vue?vue&type=style&index=0&id=d81fd23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81fd23a",
  null
  
)

export default component.exports